export enum RelationshipType {
  ONE_TO_ONE = 'ONE_TO_ONE',
  ONE_TO_MANY = 'ONE_TO_MANY',
  MANY_TO_MANY = 'MANY_TO_MANY',
  MANY_TO_ONE = 'MANY_TO_ONE',
}

export enum TableRelationshipFilterDirection {
  SINGLE = 'SINGLE',
  CROSS = 'CROSS',
}

export enum DatasetType {
  POWER_BI = 'POWER_BI',
  SQL = 'SQL'
}

export type DatasetTableRelationship = {
  relationshipSourceTableId: string
  relationshipDestinationTableId: string
  relationshipType: RelationshipType
  filterDirection: TableRelationshipFilterDirection
  sourceColumnName: string
  targetColumnName: string
}

export type DatasetDescriptionModel = {
  _id: string
  description: string
  type: DatasetType
  name: string
  isActiveVersion: boolean
  powerBiId: string
  tableRelationships: DatasetTableRelationship[]
}

export type RelationshipsItem = {
  id: string
  relationshipSourceTableId: string
  relationshipDestinationTableId: string
  relationshipType: RelationshipType
  filterDirection: TableRelationshipFilterDirection
  sourceColumnName: string
  targetColumnName: string
}

export type RelationshipsRequest = {
  relationshipSourceTableId: string
  relationshipDestinationTableId: string
  relationshipType: RelationshipType
  filterDirection: TableRelationshipFilterDirection
  sourceColumnName: string
  targetColumnName: string
}
